"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SortascendingGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/SortascendingGreyOutline"));

var _SortdescendingGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/SortdescendingGreyOutline"));

var _SortavailableGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/SortavailableGreyOutline"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * default SortIndicator for BaseTable
 */
var SortIndicator = function SortIndicator(_ref) {
  var sortOrder = _ref.sortOrder,
      className = _ref.className,
      style = _ref.style;
  var sortRef = (0, _react.useRef)(null);
  var cls = (0, _classnames["default"])("BaseTable__sort-indicator", "orion-data-grid__navigation--empty-button", className, {
    "BaseTable__sort-indicator--descending": sortOrder === "desc"
  });
  return /*#__PURE__*/_react["default"].createElement("button", {
    "aria-label": "Sort",
    ref: sortRef,
    type: "button",
    className: cls,
    style: _objectSpread({
      userSelect: "none",
      width: "20px",
      height: "20px",
      lineHeight: "20px",
      textAlign: "center"
    }, style)
  }, sortRef.current && sortRef.current.parentNode.classList.contains("orion-data-grid__header-cell--sorting") ? sortOrder === "desc" ? /*#__PURE__*/_react["default"].createElement(_SortascendingGreyOutline["default"], {
    inheritFontColor: true
  }) : /*#__PURE__*/_react["default"].createElement(_SortdescendingGreyOutline["default"], {
    inheritFontColor: true
  }) : /*#__PURE__*/_react["default"].createElement(_SortavailableGreyOutline["default"], {
    inheritFontColor: true,
    className: "oui-ml-1"
  }));
};

SortIndicator.propTypes = {
  sortOrder: _propTypes["default"].oneOf(["asc", "desc"]),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
var _default = SortIndicator;
exports["default"] = _default;